const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class InternationalTradeAgreement extends Pact {
    constructor() {
        super(
            Age.Age2,
            PactNames.InternationalTradeAgreement,
            "Each round, A produces an extra resource and B produces an extra food.",
            {}
        )
    }
}

module.exports = InternationalTradeAgreement;